var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 177,
    viewBox: "0 0 177 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 44C63.906 44 44 63.9026 44 88.5C44 113.094 63.9026 133 88.5 133C113.094 133 133 113.097 133 88.5C133 63.906 113.097 44 88.5 44ZM88.5 126.047C67.7486 126.047 50.9531 109.253 50.9531 88.5C50.9531 67.7486 67.7466 50.9531 88.5 50.9531C109.251 50.9531 126.047 67.7466 126.047 88.5C126.047 109.251 109.253 126.047 88.5 126.047ZM119.789 79.2294V92.4403C119.789 94.3606 118.233 95.9169 116.312 95.9169C114.392 95.9169 112.836 94.3606 112.836 92.4403V87.6227L100.229 100.229C98.8713 101.587 96.6699 101.587 95.3126 100.229L79.2294 84.1461L63.1462 100.229C61.7882 101.587 59.5875 101.587 58.2295 100.229C56.8721 98.8713 56.8721 96.6699 58.2295 95.3126L76.7714 76.7707C78.1294 75.4133 80.3301 75.4133 81.6881 76.7707L97.7713 92.8545L107.919 82.706H103.102C101.181 82.706 99.625 81.1497 99.625 79.2294C99.625 77.3091 101.181 75.7528 103.102 75.7528H116.312C118.261 75.7528 119.789 77.3506 119.789 79.2294Z",
    fill: "#00A094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.3d0f0fa9668ffaeb526415edba7dbb99.svg";
export { ForwardRef as ReactComponent };